import { useEffect, useState } from "react";
import http from "../lib/http";

export default function DealerProfilePage() {

  const dealer =
    JSON.parse(localStorage.getItem("dealer"));

  const [profile,setProfile] =
    useState(null);

  useEffect(()=>{

    loadProfile();

  },[]);

  const loadProfile = async()=>{

    const res =
      await http.get(
        `/api/dealers/${dealer._id}`
      );

    setProfile(res.data);

  };

  if(!profile) return null;

  return(

    <div className="card-modern">

      <div className="row">

        <div className="col-md-3">

          <img
            src={
              profile.image
                ? `${process.env.REACT_APP_API_URL}${profile.image}`
                : "/default-user.png"
            }
            alt=""
            className="img-fluid rounded"
          />

        </div>

        <div className="col-md-9">

          <h3>{profile.name}</h3>

          <table className="table">

            <tbody>

              <tr>
                <td>Contact</td>
                <td>{profile.contact}</td>
              </tr>

              <tr>
                <td>Category</td>
                <td>{profile.category}</td>
              </tr>

              <tr>
                <td>Address</td>
                <td>{profile.address}</td>
              </tr>

              <tr>
                <td>GST</td>
                <td>{profile.gstNo}</td>
              </tr>

              <tr>
                <td>PAN</td>
                <td>{profile.pan}</td>
              </tr>

              <tr>
                <td>Aadhar</td>
                <td>{profile.aadhar}</td>
              </tr>

              <tr>
                <td>Status</td>
                <td>
                  {profile.isActive
                    ? "Active"
                    : "Inactive"}
                </td>
              </tr>

              <tr>
                <td>Joined</td>
                <td>
                  {new Date(
                    profile.joinedDate
                  ).toLocaleDateString()}
                </td>
              </tr>

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
}